import { render, staticRenderFns } from "./LayoutDivasChadsMinimal.vue?vue&type=template&id=16cfad13&scoped=true&"
import script from "./LayoutDivasChadsMinimal.vue?vue&type=script&lang=js&"
export * from "./LayoutDivasChadsMinimal.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDivasChadsMinimal.vue?vue&type=style&index=0&id=16cfad13&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cfad13",
  null
  
)

export default component.exports